<template>
  <div class="flex flex-col" style="height: 100%">
    <div
      class="flex flex-justify-center flex-align-start flex-1 color-bg-fff padding-y-30"
      v-if="showSearch"
    >
      <div class="search color-bg-fff flex-center" :class="{ serachInput_active: isFocus }">
        <el-input
          v-model="mobilePhone"
          placeholder="请输入用户手机号"
          class="margin-left-20"
          @keyup.enter.native="onSearch"
          @focus="onFocus"
          @blur="onBlur"
          maxlength="11"
        />
        <div class="search-btn flex-center" @click="onSearch">
          <img style="width: 28px; height: 28px" src="./static/icon_home_search.png" />
        </div>
      </div>
    </div>
    <div
      class="color-bg-fff"
      style="min-height: 40%"
      v-loading="loading"
      element-loading-text="正在加载中～"
    >
      <user-detail v-if="infoShow" />
    </div>
    <!--打标-->
    <hit-label />
    <!--发积分-->
    <send-score />
    <!--发优惠券-->
    <send-coupon-add ref="couponAdd" />
    <!--积分明细-->
    <score-statistics-table />
    <!--成长值明细-->
    <growth-statistics-table />
    <!--城际订单详情-->
    <intercity-order ref="interCityInfo" />
    <!--摆渡、接送机订单详情-->
    <ferry-order ref="ferryOrderInfo" />
    <!--小件快运订单详情-->
    <express-order ref="expressOrderInfo" />
  </div>
</template>

<script >
import UserDetail from './components/user-detail.vue';
import HitLabel from './manage/components/hit-label.vue';
import SendScore from './manage/components/send-score.vue';
import SendCouponAdd from '@/views/marketing/components/sendcoupon/send-coupon-add';
import ScoreStatisticsTable from './manage/components/score-statistics-table.vue';
import IntercityOrder from '@/views/order/intercity/intercity-info';
import FerryOrder from '@/views/order/ferry/order-info.vue';
import ExpressOrder from '@/views/order/express/components/detail.vue';
import GrowthStatisticsTable from './manage/components/growth-statistics-table.vue';
import { Message } from 'element-ui';
import { ref, provide, nextTick } from '@vue/composition-api';
import { isValidPhoneNumber } from '@/util/util';
import { useControlCenter } from './manage/hooks/useControlCenter.js';
import { useCrmDic } from './manage/hooks/useCrmDic.js';
import { useTableList, usePageRoute } from '@/hooks';
import { getStatisticsPage } from '@/api/crm/user.js';
import { userInfoTotal } from '@/api';
import { useOrderDetail } from './manage/hooks/useOrderDetail.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const showSearch = ref(true);

  // 查询数据字典
  const {
    dicOptions,
    getLabelByCode
  } = useCrmDic();
  provide('dicOptions', dicOptions);
  provide('getLabelByCode', getLabelByCode);
  const {
    showLabel,
    showScore,
    showScoreStatistics,
    selectedUserArr,
    setSelectedUserArr,
    handleScore,
    closeScoreDialog,
    handleLabel,
    closeLabelDialog,
    viewScoreStatistics,
    showGrowthStatistics,
    viewGrowthStatistics,
    analysisRemarkToOrderInfo
  } = useControlCenter();
  // 控制弹窗
  provide('showLabel', showLabel);
  provide('showScore', showScore);
  provide('showScoreStatistics', showScoreStatistics);
  provide('showGrowthStatistics', showGrowthStatistics);
  // 选择的用户
  provide('selectedUserArr', selectedUserArr);
  // 打标
  provide('handleLabel', handleLabel);
  provide('closeLabelDialog', closeLabelDialog);
  // 发积分
  provide('handleScore', handleScore);
  provide('closeScoreDialog', closeScoreDialog);
  // 查看积分明细
  provide('viewScoreStatistics', viewScoreStatistics);
  provide('viewGrowthStatistics', viewGrowthStatistics);
  provide('analysisRemarkToOrderInfo', analysisRemarkToOrderInfo);

  // 明细表格
  const {
    loading: statisticsLoading,
    tableData: statisticsTableData,
    pageState: statisticsPageState,
    searchParam: statisticsSearchParam,
    handleCurrentChange: statisticsHandleCurrentChange,
    handleSizeChange: statisticsHandleSizeChagne,
    search: statisticsSearch
  } = useTableList(getStatisticsPage, {}, true, null, false);
  provide('statisticsLoading', statisticsLoading);
  provide('statisticsTableData', statisticsTableData);
  provide('statisticsPageState', statisticsPageState);
  provide('statisticsSearchParam', statisticsSearchParam);
  provide('statisticsHandleCurrentChange', statisticsHandleCurrentChange);
  provide('statisticsHandleSizeChagne', statisticsHandleSizeChagne);
  provide('statisticsSearch', statisticsSearch);

  // 发券
  const couponAdd = ref({});
  const handleCoupon = row => {
    setSelectedUserArr(row);
    const phoneStr = selectedUserArr.value.map(item => {
      return item.phone || item.mobilePhone;
    }).join(',');
    nextTick(() => {
      couponAdd.value.init && couponAdd.value.init(phoneStr, 'user');
    });
  };
  provide('handleCoupon', handleCoupon);

  // 是否获取焦点
  const isFocus = ref(false);
  const onFocus = () => {
    isFocus.value = true;
  };
  const onBlur = () => {
    isFocus.value = false;
  };

  // 搜索
  const mobilePhone = ref('');
  const loading = ref(false);
  const infoShow = ref(false);
  const onSearch = () => {
    if (!isValidPhoneNumber(mobilePhone.value)) {
      Message.warning('请输入正确的手机号码');
      return;
    }
    if (loading.value) {
      return;
    }
    infoShow.value = false;
    getUserInfo(mobilePhone.value);
  };

  // 用户信息
  const userInfo = ref({});
  provide('userInfo', userInfo);
  const getUserInfo = async (param, type = '') => {
    loading.value = true;
    const {
      code,
      data
    } = await userInfoTotal(param, type);
    loading.value = false;
    if (code === 0) {
      userInfo.value = data;
      infoShow.value = true;
    }
  };
  provide('getUserInfo', getUserInfo);

  // 查看订单详情
  const {
    interCityInfo,
    // closeInterCityLoading,
    ferryOrderInfo,
    expressOrderInfo,
    viewOrderDetail
  } = useOrderDetail();
  provide('viewOrderDetail', viewOrderDetail);

  // 获取路由信息
  const {
    getRoute
  } = usePageRoute();
  const route = getRoute();
  const {
    userId = ''
  } = route.params || {};
  if (userId) {
    showSearch.value = false;
    infoShow.value = false;
    getUserInfo(userId, 'userId');
  }
  return {
    showSearch,
    couponAdd,
    isFocus,
    onFocus,
    onBlur,
    mobilePhone,
    loading,
    infoShow,
    onSearch,
    interCityInfo,
    ferryOrderInfo,
    expressOrderInfo
  };
};
__sfc_main.components = Object.assign({
  UserDetail,
  HitLabel,
  SendScore,
  SendCouponAdd,
  ScoreStatisticsTable,
  GrowthStatisticsTable,
  IntercityOrder,
  FerryOrder,
  ExpressOrder
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .search {
    transition: all 0.3s linear;
    width: 35%;
    height: 45px;
    border-radius: 42px;
    margin-left: 15px;
    box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.1);

    .search-btn {
      height: 100%;
      width: 20%;
      background-color: #4292ff;
      border-radius: 0px 42px 42px 0px;
      box-shadow: 0px 0px 22px 1px rgba(0, 0, 0, 0.05);
    }
    ::v-deep .el-input__inner {
      border: none !important;
      box-shadow: none !important;
      padding: 0px; //前边边距去掉
    }
  }

  .serachInput_active {
    transition: all 0.3s linear;
    transform: scale(1.05, 1.05);
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1);
  }
</style>
